<template>
  <v-select
    :label="label"
    rounded
    filled
    dense
    item-value="id"
    item-text="title"
    item-color="secondary"
    color="secondary"
    background-color="transparent"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <slot name="label">{{ label }}</slot>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
